function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { finectAPI } from '@finect/front-utils/finectAPI';
import { UMBRELLA_TAG, BANK_TAG } from './data';
const ENTITY_TYPES = ['profile', 'tag', 'product', 'article', 'question', 'pill'];
const PROFILE_SUBTYPES = ['user', 'company', 'group'];
const PRODUCT_SUBTYPES = ['fund', 'plan', 'stock', 'sicav', 'etf', 'equity', 'index', 'exchange'];
const logError = err => console.error(err);
export const getUser = cookies => finectAPI({
  version: 'v4',
  path: 'users/me',
  method: 'GET',
  credentials: cookies,
  onSuccess: user => user.data,
  onError: error => logError(error)
});
export const getTags = function () {
  let limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
  let cookies = arguments.length > 1 ? arguments[1] : undefined;
  return finectAPI({
    version: 'v4',
    path: "contents/tags?filter=window+eq+true+and+umbrella+eq+'".concat(UMBRELLA_TAG, "'&orderby=evergreen").concat(limit ? "&limit=".concat(limit) : ''),
    method: 'GET',
    credentials: cookies,
    onSuccess: tags => tags.data,
    onError: error => logError(error)
  });
};
export const getBanks = cookies => finectAPI({
  version: 'v4',
  path: "contents/profiles/publics/organizations?filter=tag+eq+".concat(BANK_TAG, "&orderby=evergreen"),
  method: 'GET',
  credentials: cookies,
  onSuccess: banks => banks.data,
  onError: error => logError(error)
});
export const getProductFamilies = cookies => finectAPI({
  version: 'v4',
  path: "products/catalogs/families?tag=".concat(UMBRELLA_TAG),
  method: 'GET',
  credentials: cookies,
  onSuccess: _ref => {
    let {
      data
    } = _ref;
    return data;
  },
  onError: error => logError(error)
});
const reduceSubs = subs => subs.reduce((subsReduc, sub) => {
  const newSubs = _objectSpread({}, subsReduc);
  const prop = sub.type;
  if (!newSubs.hasOwnProperty(prop)) newSubs[prop] = [];
  newSubs[prop].push(sub.entity.id.toUpperCase());
  return newSubs;
}, {});
export const getSubscriptions = cookies => finectAPI({
  version: 'v4',
  path: 'users/me/subscriptions',
  method: 'GET',
  credentials: cookies,
  onSuccess: subs => reduceSubs(subs.data),
  onError: error => logError(error)
});
export const mapType = entity => {
  if (ENTITY_TYPES.includes(entity)) return entity;
  if (PRODUCT_SUBTYPES.includes(entity)) return 'product';
  if (PROFILE_SUBTYPES.includes(entity)) return 'profile';
};
export const subscribe = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let id = arguments.length > 1 ? arguments[1] : undefined;
  let cookies = arguments.length > 2 ? arguments[2] : undefined;
  return finectAPI({
    version: 'v4',
    path: "users/me/subscriptions",
    method: 'POST',
    body: {
      id,
      type
    },
    credentials: cookies,
    onSuccess: _ref2 => {
      let {
        code = 201
      } = _ref2;
      return {
        code
      };
    },
    onError: error => {
      logError(error);
      return {
        code: error.status
      };
    }
  });
};
export const unsubscribe = (type, id, cookies) => finectAPI({
  version: 'v4',
  path: "users/me/subscriptions?type=".concat(type, "&id=").concat(id),
  method: 'DELETE',
  credentials: cookies,
  onSuccess: _ref3 => {
    let {
      code = 204
    } = _ref3;
    return {
      code
    };
  },
  onError: error => {
    logError(error);
    return {
      code: error.status
    };
  }
});
export const search = (query, index, cookies) => finectAPI({
  version: 'v4',
  path: "search?".concat(index ? "type=".concat(index, "&") : '', "q=").concat(encodeURIComponent(query)),
  method: 'GET',
  credentials: cookies,
  onSuccess: hits => hits.data,
  onError: error => logError(error)
});
export const getViewedProducts = cookies => finectAPI({
  version: 'v4',
  path: 'users/me/viewed/products',
  method: 'GET',
  credentials: cookies,
  onSuccess: views => views.data,
  onError: error => logError(error)
});